import { CustomTravelEstimateType } from '@pkgtour-workspace/common/dist/constants/estimate';
import { atomWithReset } from 'jotai/utils';
import { CodeType } from '@/components/CustomTravel/CustomInit';

export type Maybe<T> = T | null;

export interface GroupType extends Pick<CodeType, 'code' | 'name'> {}

export interface CustomTravelSchedule {
  schedules: { from: string; to: string }[];
  flexible?: boolean;
}

export interface CustomTravelPersonalCount {
  adult: number;
  child?: number;
  infant?: number;
  flexible?: boolean;
}

export interface CustomTravelSpecialNote {
  code: string;
  name: string;
  etcName?: string;
}

export enum BudgetType {
  PER_PERSON = 'perPerson',
  TOTAL = 'total',
}

export enum BudgetFlexibility {
  FLEXIBLE = 'flexible',
  FIXED = 'fixed',
  ECONOMICAL = 'economical',
}

export interface CustomTravelBudget {
  budgetType: BudgetType;
  amount: number;
  flexibility: BudgetFlexibility;
}

export interface CustomTravelContact {
  channel: 'kakaotalk' | 'phone';
  phoneNo: string;
  nationNo: string;
}

export interface CustomTravelLocation {
  codes: string[] | null;
  name: Maybe<string> | undefined;
}

export enum CustomFlightAirlineType {
  FSC = 'fsc',
  LCC = 'lcc',
  FOREIGN_AIRLINE = 'foreignAirline',
  ALL = 'all',
}

export interface CustomFlight {
  airlineType: CustomFlightAirlineType;
  preferredAirlines?: string[];
}

export interface CustomHotel {
  minStarRate: number;
  preferredHotels?: string[];
}

export interface CustomTravelFormState {
  requirements?: CodeType[];
  estimateType?: CustomTravelEstimateType;
  groupType?: GroupType;
  destinations?: CustomTravelLocation[];
  tourSchedule?: CustomTravelSchedule;
  personalCount?: CustomTravelPersonalCount;
  specialNote?: CustomTravelSpecialNote;
  budget?: CustomTravelBudget;
  contactTradeId?: string;
  contact?: CustomTravelContact;
  flight?: CustomFlight;
  mealOrShoppings?: CodeType[];
  hotel?: CustomHotel;
  additionalRequirementCheckList?: CodeType[];
  additionalRequirements?: string;
}

export const customTravelFormStateAtom = atomWithReset<CustomTravelFormState>({});
